import Button from "@/components/shared/Button";
import Title from "@/components/shared/Title";
import { useSiteData } from "@/context/SiteDataContext";
import React from "react";

const HeroSection = () => {
  const { siteData, loading } = useSiteData();
  const heroData = siteData?.hero || {};

  if (loading) return <p>Loading hero data...</p>;

  return (
    <section className="relative flex w-full flex-col items-center justify-between gap-4 px-4 py-6 md:flex-row md:px-12 xl:gap-12 xl:px-16 xl:py-0">
      {/* Hero Shadow */}
      <img
        src="/assets/images/hero-shadow.webp"
        alt="Hero Shadow"
        className="absolute -end-0 bottom-0 w-8/12"
      />

      {/* Hero Content */}
      <div className="z-10 items-center space-y-8 md:w-1/2">
        {/* Logo & Welcome */}
        <div className="flex flex-col items-center gap-6 text-center">
          <img
            src={heroData.logo}
            alt="Hero"
            className="w-25 md:w-38 xl:w-40"
          />
          <Title
            title={heroData.welcomeText}
            className="text-base transition-all duration-200 hover:scale-105 md:text-xl"
          />
        </div>

        {/* Title & Subtitle */}
        <div className="space-y-2 text-center">
          <p className="text-2xl font-bold text-[#1C280C] md:text-xl xl:text-4xl xl:font-medium">
            {heroData.title}
          </p>
          <p className="text-base font-medium text-[#696969] xl:text-2xl">
            {heroData.subtitle}
          </p>
        </div>

        {/* Call to Action */}
        <Button
          text="Contact Now"
          url={heroData.cta}
          blank
          className="justify-self-center xl:px-16 xl:text-2xl"
        />
      </div>

      {/* Hero Banner */}
      <img
        src={heroData.banner}
        alt="Hero"
        fetchpriority="high"
        className="z-10 max-w-64 md:max-w-83 xl:max-w-132 xl:mb-8"
      />
    </section>
  );
};

export default HeroSection;
